const guiColors = {
    'motion-primary': '#13501B',
    'motion-primary-transparent': '#13501BE6',
    'motion-tertiary': '#0d3a13',

    'looks-secondary': '#13501B',
    'looks-transparent': '#13501B59',
    'looks-light-transparent': '#13501B26',
    'looks-secondary-dark': 'hsla(128, 62%, 19%, 1)',

    'extensions-primary': 'hsla(128, 62%, 35%, 1)',
    'extensions-tertiary': 'hsla(128, 62%, 19%, 1)',
    'extensions-transparent': 'hsla(128, 62%, 35%, 0.35)',
    'extensions-light': 'hsla(128, 40%, 80%, 1)',

    'drop-highlight': '#13501B'
};

const blockColors = {
    checkboxActiveBackground: '#13501B',
    checkboxActiveBorder: '#0d3a13'
};

export {
    guiColors,
    blockColors
};
